import { render, staticRenderFns } from "./addNewWork.vue?vue&type=template&id=235667aa&scoped=true&"
import script from "./addNewWork.vue?vue&type=script&lang=js&"
export * from "./addNewWork.vue?vue&type=script&lang=js&"
import style0 from "./addNewWork.vue?vue&type=style&index=0&id=235667aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235667aa",
  null
  
)

export default component.exports